import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";
import { Link } from "react-router-dom";

const STEPS = [
  {
    number: "01",
    title: "Free On-Site Estimate",
    desc: "Call us or submit an online request and we'll schedule a convenient time to assess your tree service needs. One of our ISA Certified Arborists visits your property, evaluates the tree(s), and discusses the best approach with you. This is 100% free with no obligation.",
    img: "https://public.readdy.ai/ai/img_res/8ce301450e94812199a8572c98bad6a2.jpg",
    icon: "ri-search-eye-line",
    color: "#e8632a",
  },
  {
    number: "02",
    title: "Detailed Written Quote",
    desc: "You receive a clear, itemized written quote outlining exactly what will be done, the equipment needed, timeline, and total cost. We explain every line item so there are no surprises. We never pressure you to accept — take your time.",
    img: "https://readdy.ai/api/search-image?query=professional%20arborist%20showing%20estimate%20quote%20document%20to%20homeowner%20at%20front%20door%20northern%20virginia%20residential%20home%20handshake%20agreement&width=600&height=450&seq=proc002&orientation=landscape",
    icon: "ri-file-text-line",
    color: "#1a3a2e",
  },
  {
    number: "03",
    title: "Flexible Scheduling",
    desc: "Once you accept the quote, we schedule a date and time that works for you. We offer weekday and weekend appointments and have flexible windows. For emergencies, we can often respond same-day or next-day.",
    img: "https://readdy.ai/api/search-image?query=professional%20scheduling%20appointment%20calendar%20tree%20service%20customer%20call%20center%20friendly%20team%20northern%20virginia%20office%20phone&width=600&height=450&seq=proc003&orientation=landscape",
    icon: "ri-calendar-check-line",
    color: "#e8632a",
  },
  {
    number: "04",
    title: "Professional Service Day",
    desc: "Our fully equipped crew arrives on time, introduces themselves, and walks through the plan before starting. We use professional equipment — bucket trucks, cranes when needed, precise rigging systems — to complete the job safely and efficiently.",
    img: "https://readdy.ai/api/search-image?query=professional%20tree%20service%20crew%20arriving%20residential%20driveway%20bucket%20truck%20chipper%20truck%20gear%20equipment%20ready%20team%20northern%20virginia&width=600&height=450&seq=proc004&orientation=landscape",
    icon: "ri-tools-line",
    color: "#1a3a2e",
  },
  {
    number: "05",
    title: "Complete Cleanup & Walkthrough",
    desc: "After all tree work is complete, we do a thorough cleanup — all branches, logs, and wood chips are removed or spread as mulch per your preference. We walk you through the completed work and ensure you're 100% satisfied before we leave.",
    img: "https://readdy.ai/api/search-image?query=tree%20service%20crew%20cleanup%20after%20job%20raking%20hauling%20wood%20chips%20branches%20clean%20residential%20property%20northern%20virginia%20satisfied%20homeowner&width=600&height=450&seq=proc005&orientation=landscape",
    icon: "ri-check-double-line",
    color: "#e8632a",
  },
];

export default function ProcessPage() {
  return (
    <>
      <Header />
      <main>
        <section className="py-20 bg-[#1a3a2e] text-center">
          <div className="max-w-4xl mx-auto px-4">
            <span className="text-[#e8632a] font-bold text-sm uppercase tracking-widest block mb-3">How It Works</span>
            <h1 className="text-5xl font-black text-white mb-4">Our Simple 5-Step Process</h1>
            <p className="text-white/70 text-xl">From first call to final cleanup — here's exactly what you can expect when you hire Diversified Tree Services.</p>
          </div>
        </section>

        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 lg:px-8 space-y-20">
            {STEPS.map((step, i) => (
              <div key={step.number} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${i % 2 === 1 ? "" : ""}`}>
                <div className={`${i % 2 === 1 ? "lg:order-2" : ""}`}>
                  <div className="rounded-2xl overflow-hidden h-72">
                    <img src={step.img} alt={step.title} className="w-full h-full object-cover object-top" />
                  </div>
                </div>
                <div className={`${i % 2 === 1 ? "lg:order-1" : ""}`}>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-14 h-14 flex items-center justify-center rounded-full text-white font-black text-xl" style={{ backgroundColor: step.color }}>
                      {step.number}
                    </div>
                    <div className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-lg">
                      <i className={`${step.icon} text-xl`} style={{ color: step.color }}></i>
                    </div>
                  </div>
                  <h2 className="text-3xl font-black text-[#1e1e1e] mb-4">{step.title}</h2>
                  <p className="text-gray-600 leading-relaxed text-base">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="py-20 bg-[#f8f6f3]">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <h2 className="text-4xl font-black text-[#1e1e1e] mb-4">Have Questions About Our Process?</h2>
            <p className="text-gray-500 mb-8">We're happy to walk you through everything before you commit to anything. Give us a call or check our FAQ page.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="tel:+15407764488" className="flex items-center justify-center gap-2 px-8 py-4 bg-[#e8632a] text-white font-black rounded-lg uppercase tracking-wide hover:bg-[#d0541e] cursor-pointer whitespace-nowrap">
                <i className="ri-phone-fill"></i>(540) 776-4488
              </a>
              <Link to="/faq" className="px-8 py-4 border-2 border-[#1a3a2e] text-[#1a3a2e] font-black rounded-lg uppercase tracking-wide hover:bg-[#1a3a2e] hover:text-white transition-all cursor-pointer whitespace-nowrap">
                View FAQ
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
